import React from 'react'
import { Link } from 'react-router-dom'

import { Content, Text } from '../../components'
import { useApi } from '../../providers'
import { categoryPath } from '../../routes'

import { useStyle } from './home-categories.styles'

const TILE_COUNT = 4

export const HomeCategories = () => {
  const { menu } = useApi()
  const { data } = menu.useMainMenu()
  const classes = useStyle()

  const categories = (data?.shop.navigation.main.items || [])
    .flatMap(({ category }) => (category ? [category] : []))
    .slice(0, TILE_COUNT)

  if (categories.length === 0) {
    return null
  }

  return (
    <Content className={classes.container}>
      <Text
        className={classes.title}
        preset="h5"
        text="Explore these custom-made categories"
        tx="home.categories.title"
      />
      <div className={classes.grid}>
        {categories.map((category) => (
          <Link
            key={category.id}
            className={classes.tile}
            to={categoryPath(category)}
          >
            <div
              data-testid="category-image"
              className={classes.image}
              style={{
                backgroundImage: category.backgroundImage?.url
                  ? `url("${category.backgroundImage.url}")`
                  : undefined
              }}
            />
            <Text className={classes.name} preset="h5" text={category.name} />
          </Link>
        ))}
      </div>
    </Content>
  )
}
